import { render } from "./CreateTodo.vue?vue&type=template&id=2887b829&bindings={\"newTodo\":\"data\",\"addTodo\":\"options\"}"
import script from "./CreateTodo.vue?vue&type=script&lang=js"
export * from "./CreateTodo.vue?vue&type=script&lang=js"
script.render = render

export default script